// --------------------------------------------------------------------------
// Form scroll to error - scrolls to the first validation error in the form
// --------------------------------------------------------------------------
// Author:      RSPB
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');

module.exports = function (options) {
    var ref = { $root: options.context };

    function init() {
        ref.$form = ref.$root.find('form');

        function scrollToElement(offset, duration) {
            $('html, body').animate({
                scrollTop: offset
            }, duration);
        }

        ref.$root.on('click', 'button[type="submit"]', function () {
            // Wait for validation script to complete
            setTimeout(function () {

                // Find the first error
                var $firstError = ref.$form.find('.field-validation-error').first();

                // If one exists
                if ($firstError.length > 0) {
                    // Scroll to the first error
                    scrollToElement($firstError.offset().top - 10, 1000);
                }
            }, 200);
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/form-scroll-to-error.js
// module id = 484
// module chunks = 0